import { CARD_PRODUCT, getProductsByTypes, getProductsOrder, getProductsRegistryMap } from 'axp-product-ducks';
export const getOrigin = state => state.getIn(['browser', 'location', 'origin']);
export const getPublicGuid = state => state.getIn(['browser', 'cookies', 'blueboxpublic']);
export const getAccountToken = state => {
  const [accountToken] = getProductsOrder(state);
  return accountToken;
};
export const getMappedAccountsWithMarkets = state => {
  const registryMap = getProductsRegistryMap(state);
  const cardProducts = getProductsByTypes(state, [CARD_PRODUCT]);
  const markets = {};
  const {
    [CARD_PRODUCT]: {
      productsList = {}
    } = {}
  } = cardProducts;
  const mappedAccounts = Object.values(registryMap).map(registryItem => {
    const {
      type,
      opaqueAccountId
    } = registryItem;
    const product = registryItem;
    const accountToken = opaqueAccountId;
    let locale;
    let lineOfBusiness;
    let relationship;
    let paymentType;
    let roles;
    if (type === CARD_PRODUCT) {
      var _cardProduct$profile, _cardProduct$profile2, _cardProduct$account, _cardProduct$product, _cardProduct$product2, _cardProduct$authoriz, _cardProduct$authoriz2;
      const cardProduct = productsList[opaqueAccountId];
      const marketName = cardProduct === null || cardProduct === void 0 ? void 0 : (_cardProduct$profile = cardProduct.profile) === null || _cardProduct$profile === void 0 ? void 0 : _cardProduct$profile.country;
      locale = cardProduct === null || cardProduct === void 0 ? void 0 : (_cardProduct$profile2 = cardProduct.profile) === null || _cardProduct$profile2 === void 0 ? void 0 : _cardProduct$profile2.locale_preference;
      relationship = cardProduct === null || cardProduct === void 0 ? void 0 : (_cardProduct$account = cardProduct.account) === null || _cardProduct$account === void 0 ? void 0 : _cardProduct$account.relationship;
      paymentType = cardProduct === null || cardProduct === void 0 ? void 0 : (_cardProduct$product = cardProduct.product) === null || _cardProduct$product === void 0 ? void 0 : _cardProduct$product.payment_type;
      lineOfBusiness = cardProduct === null || cardProduct === void 0 ? void 0 : (_cardProduct$product2 = cardProduct.product) === null || _cardProduct$product2 === void 0 ? void 0 : _cardProduct$product2.line_of_business_type;
      roles = (_cardProduct$authoriz = cardProduct === null || cardProduct === void 0 ? void 0 : (_cardProduct$authoriz2 = cardProduct.authorized_user_profile) === null || _cardProduct$authoriz2 === void 0 ? void 0 : _cardProduct$authoriz2.roles) !== null && _cardProduct$authoriz !== void 0 ? _cardProduct$authoriz : [];
      markets[marketName] = marketName;
    } else {
      locale = product.localePreference;
    }
    const values = {
      accountToken,
      locale,
      productType: type,
      ...(lineOfBusiness ? {
        lineOfBusiness
      } : {}),
      ...(relationship ? {
        relationship
      } : {}),
      ...(paymentType ? {
        paymentType
      } : {}),
      ...(roles ? {
        roles
      } : {})
    };
    return values;
  });
  return {
    markets: Object.values(markets).filter(Boolean),
    mappedAccounts
  };
};